module.exports = __webpack_public_path__ + "img/blue-dash.85d68ee6.svg";